import { VoidFunctionComponent } from 'react';
import { useAccount } from 'wagmi';
import { Text } from '@react-three/drei';
import { Screen } from '@/components/Screen';
import { useResponsive } from '@/hooks/useResponsive';
import { garamondNarrowLight } from '@/lib/fonts';
import { PlaystationButton } from '@/components/PlaystationButton';
import { BUY_URL } from '@/lib/globals';

interface Props {
    cancel: () => void;
}
export const AlreadyMinted: VoidFunctionComponent<Props> = ({ cancel }) => {
    const { responsiveValue } = useResponsive();
    const { address } = useAccount();
    const textProps = {
        textAlign: 'center' as const,
        font: garamondNarrowLight,
        fontSize: responsiveValue(0.36, 0.28),
        color: 'white',
        maxWidth: responsiveValue(5.7, 3.3),
        lineHeight: responsiveValue(1.1, 1.1),
    };
    const walletAddress = address ? `${address.substring(0, 8)}...${address.substring(address.length - 2)}` : 'anon';

    return (
        <Screen>
            <Text position={[0, 0.08, 0]} {...textProps}>
                Hello, {walletAddress}.
            </Text>
            <Text position={[0, -0.5, 0]} {...textProps}>
                You appear to already have claimed your Onlybots. You cannot claim another here.
            </Text>
            <group
                position={[responsiveValue(-0.8, -0.7), responsiveValue(-1.7, -1.9), 0]}
                scale={responsiveValue(1, 0.85)}
            >
                <PlaystationButton
                    clickableAreaDimensions={[4, 0.7]}
                    maxWidth={4}
                    position={[-1.0, 0, 0]}
                    icon="square"
                    label="ONLYBOTS MARKETPLACE"
                    action={() => {
                        window.location.href = BUY_URL;
                    }}
                />
                <PlaystationButton
                    clickableAreaDimensions={[3, 0.7]}
                    position={[responsiveValue(0.1, 0), responsiveValue(-0.8, -1), 0]}
                    icon="x"
                    label={'CANCEL'}
                    action={cancel}
                />
            </group>
        </Screen>
    );
};
